/*
* @Description: 送检
* @Author: yjx
* @Date: 2021-11-19 18:22:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-01-04 15:35:35
*/
import request from '@/utils/request'
// 供应商下拉数据
export function queryRawContractList(params) {
  return request({
    url: '/icps/system/sign/dataCollection/contract/queryRawContractList',
    method: 'get',
    params
  })
}

// 添加送检
export function saveSubmitInspection(data) {
    return request({
        url: '/icps/system/sign/intelligent/make/saveSubmitInspection',
        method: 'post',
        data
    })
}

// 获取混凝土检验数据
export function queryResult(params) {
    return request({
      url: '/icps/system/sign/intelligent/ConcreteQuality/queryResult',
      method: 'get',
      params
    })
  }

